// extracted by mini-css-extract-plugin
export default {"container":"eq-z","brandName":"fq-z","productName":"gq-z","productNamePdpEnhancements":"hq-z","breakLongProductName":"iq-z"};